module.exports = __webpack_public_path__ + "static/img/logo14.2ade719.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo14.png
// module id = D3dl
// module chunks = 1